(function() {
  if (window.__NCCardSetup) return;
  window.__NCCardSetup = true;

  /* Color keywords for alt-text matching */
  var COLOR_TERMS = ['rose','pink','yellow','white','platinum','silver'];

  /* Price filter range (filter.v.price.*, store currency) in the visitor's currency, in cents */
  function activePriceRange() {
    var params = new URLSearchParams(window.location.search);
    var gte = parseFloat(params.get('filter.v.price.gte'));
    var lte = parseFloat(params.get('filter.v.price.lte'));
    if (isNaN(gte) && isNaN(lte)) return null;
    var rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    return {
      min: isNaN(gte) ? 0 : Math.round(gte * rate) * 100,
      max: isNaN(lte) ? Infinity : Math.round(lte * rate) * 100
    };
  }

  /* Format cents like the shop's money format, from a sample of 123456789 cents
     ("£1,234,567.89", "1.234.567,89 €" or without decimals "$1,234,568") */
  function formatMoney(cents, sample) {
    sample = String(sample || '');
    var group = function(whole, sep) { return whole.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    var m = sample.match(/^(.*?)1(\D?)234\2(?:567)(\D)89(.*)$/);
    if (m) {
      var parts = (cents / 100).toFixed(2).split('.');
      return m[1] + group(parts[0], m[2]) + m[3] + parts[1] + m[4];
    }
    m = sample.match(/^(.*?)1(\D?)234\2(?:568)(.*)$/);
    if (m) return m[1] + group(String(Math.round(cents / 100)), m[2]) + m[3];
    return '';
  }

  /* Re-sync every card's price with the current price filter (called by nc-price-filter.js) */
  window.__NCSyncCardPrices = function() {
    document.querySelectorAll('[data-nc-card]').forEach(function(card) {
      if (card.__ncSyncPrice) card.__ncSyncPrice();
    });
  };

  function initCard(card) {
    var productId = card.dataset.productId;
    var gallery   = card.querySelector('[data-gallery]');
    var allSlides = Array.from(card.querySelectorAll('[data-slide]'));
    var slides    = allSlides.slice();
    var dots      = Array.from(card.querySelectorAll('[data-dot]'));
    var prevBtn      = card.querySelector('[data-g-prev]');
    var nextBtn      = card.querySelector('[data-g-next]');
    var progressBar  = card.querySelector('[data-scrollbar]')  || card.querySelector('[data-progress]');
    var progressFill = card.querySelector('[data-scrollbar-drag]') || card.querySelector('[data-progress-fill]');
    var swatches  = Array.from(card.querySelectorAll('[data-swatch-variant-id]'));
    var label     = card.querySelector('[data-swatch-display]');
    var swatchActiveClass = (swatches.length > 0 && swatches[0].className.indexOf('nc-col-card__swatch') > -1)
      ? 'nc-col-card__swatch--active'
      : 'nc-card__swatch--active';

    /* ── Build image→variant_ids map from product JSON (native Shopify) ── */
    var imgVariantMap = {};

    /* ── Variant→color map: read from Liquid-generated window.__NCVarColorMap
         This is NOT truncated unlike product | json ── */
    var variantColorMap = (window.__NCVarColorMap && productId)
      ? (window.__NCVarColorMap[productId] || {})
      : {};

    if (productId) {
      var jsonEl = document.getElementById('NCProduct-' + productId) || document.getElementById('NCPData-' + productId);
      if (jsonEl) {
        try {
          var pData = JSON.parse(jsonEl.textContent);
          (pData.images || []).forEach(function(img) {
            imgVariantMap[String(img.id)] = img.variant_ids || [];
          });
        } catch(e) {}
      }
    }

    /* ── Colour helpers (same logic as variant_change.js) ── */
    function getAltColorTerm(str) {
      var s = (str || '').toLowerCase().replace(/-/g, ' ');
      return COLOR_TERMS.find(function(t) { return s.indexOf(t) > -1; }) || null;
    }

    /* Detect color term from swatch label / value directly — no variantColorMap needed */
    function getSwatchColorTerm(variantId) {
      var sw = swatches.find(function(s) { return s.dataset.swatchVariantId === String(variantId); });
      if (!sw) return null;
      /* Try label first, then color value, then title */
      var str = sw.dataset.swatchLabel || sw.dataset.swatchColor || sw.getAttribute('title') || '';
      return getAltColorTerm(str);
    }

    /* Track last colour to skip re-render when a non-colour option changes */
    var lastColorTerm = null;

    /* ── Apply filter: template-slot DOM reordering ──
       - shared images (no colour keyword in alt) → always at their position
       - selected colour images → substituted into template colour slots
       - other colour images → excluded and hidden
       Slides are physically reordered via appendChild so positions are preserved. ── */
    function applyFilter(variantId) {
      var selColorTerm = getSwatchColorTerm(variantId);

      /* Skip if colour didn't change */
      if (selColorTerm !== null && selColorTerm === lastColorTerm) return;
      lastColorTerm = selColorTerm;

      /* Build colour groups from stable allSlides reference */
      var colorGroups = {};
      allSlides.forEach(function(s) {
        if (s.dataset.videoId) return;
        var c = getAltColorTerm(s.dataset.imgAlt);
        if (c) {
          if (!colorGroups[c]) colorGroups[c] = [];
          colorGroups[c].push(s);
        }
      });

      /* First colour term in allSlides = template */
      var firstColorTerm = null;
      for (var i = 0; i < allSlides.length; i++) {
        if (allSlides[i].dataset.videoId) continue;
        var c0 = getAltColorTerm(allSlides[i].dataset.imgAlt);
        if (c0) { firstColorTerm = c0; break; }
      }

      /* No colour images at all → show everything, no reorder */
      if (!firstColorTerm) {
        slides = allSlides.slice();
        allSlides.forEach(function(s) { s.removeAttribute('data-hidden'); });
        dots.forEach(function(d) { d.removeAttribute('data-hidden'); });
        if (gallery) resetSlides();
        return;
      }

      var templateSlides = colorGroups[firstColorTerm] || [];
      var selGroup = (selColorTerm && colorGroups[selColorTerm]) || templateSlides;
      var slotIdx = 0;
      var newOrder = [];

      allSlides.forEach(function(s) {
        /* Videos always included at their position */
        if (s.dataset.videoId) { newOrder.push(s); return; }

        var c = getAltColorTerm(s.dataset.imgAlt);
        if (!c) {
          /* Shared / model image → keep at its position */
          newOrder.push(s);
        } else if (templateSlides.indexOf(s) > -1) {
          /* Template colour slot → substitute with selected colour image */
          newOrder.push(selGroup[slotIdx] || s);
          slotIdx++;
        }
        /* else: non-template colour slide → excluded */
      });

      /* Fallback: if newOrder empty, show all */
      if (!newOrder.length) newOrder = allSlides.slice();

      /* Physically reorder DOM so visual positions match */
      if (gallery) newOrder.forEach(function(s) { gallery.appendChild(s); });

      /* Update navigation reference to new order */
      slides = newOrder;

      /* Show slides in newOrder; hide all others */
      allSlides.forEach(function(s) {
        newOrder.indexOf(s) > -1
          ? s.removeAttribute('data-hidden')
          : s.setAttribute('data-hidden', '');
      });

      /* Sync dots */
      dots.forEach(function(d) {
        var matched = newOrder.some(function(s) {
          return (d.dataset.imgId && s.dataset.imgId === d.dataset.imgId) ||
                 (d.dataset.videoId && s.dataset.videoId === d.dataset.videoId);
        });
        matched ? d.removeAttribute('data-hidden') : d.setAttribute('data-hidden', '');
      });

      if (gallery) resetSlides();
    }

    /* ── Transform-based infinite slider ── */
    var curIdx = 0;
    var busy   = false;

    /* Swiper-style spaceBetween: gap visible between slides as they cross */
    var SLIDE_GAP = 5;
    var OFF_RIGHT = 'translateX(calc(100% + ' + SLIDE_GAP + 'px))';
    var OFF_LEFT  = 'translateX(calc(-100% - ' + SLIDE_GAP + 'px))';

    function getVis() {
      return slides.filter(function(s) { return !s.hasAttribute('data-hidden'); });
    }

    function pauseVideoInSlide(slide) {
      var wrap  = slide && slide.querySelector('[data-video-wrap]');
      var video = wrap && wrap.querySelector('[data-video-el]');
      if (video) { video.pause(); video.currentTime = 0; }
      if (wrap)  { wrap.classList.remove('playing'); }
    }

    function playVideoInSlide(slide) {
      var wrap  = slide && slide.querySelector('[data-video-wrap]');
      var video = wrap && wrap.querySelector('[data-video-el]');
      if (video && wrap) {
        wrap.classList.add('playing');
        video.play().catch(function() {});
      }
    }

    /* Set all slides to their initial off-screen positions */
    function resetSlides() {
      var vis = getVis();
      vis.forEach(function(s, i) {
        s.style.transition = 'none';
        s.style.transform  = i === 0 ? 'translateX(0)' : OFF_RIGHT;
        s.classList.toggle('nc-active', i === 0);
        void s.offsetWidth; /* force reflow so transition: none takes effect */
        s.style.transition = '';
        if (i !== 0) pauseVideoInSlide(s);
      });
      curIdx = 0;
      updateDot();
      updateProgress();
    }

    function updateDot() {
      var visDots = dots.filter(function(d) { return !d.hasAttribute('data-hidden'); });
      visDots.forEach(function(d, i) {
        d.classList.toggle('nc-card__dot--active', i === curIdx);
      });
    }

    function updateProgress() {
      var vis = getVis();
      var total = vis.length;
      if (!progressFill) return;
      if (total <= 1) { if (progressBar) progressBar.setAttribute('data-hidden', ''); return; }
      if (progressBar) progressBar.removeAttribute('data-hidden');
      /* Swiper-style: drag handle width = 1/total, left = curIdx/total */
      var dragPct = 100 / total;
      progressFill.style.width = dragPct + '%';
      progressFill.style.left  = (curIdx * dragPct) + '%';
    }

    var pendingParkTimeout = null;
    var lastOutgoingEl     = null;

    /* Animate from curIdx to an arbitrary targetIdx in one smooth motion
       (used by navigate() for adjacent steps, and by hover-out to glide
       straight back to the first slide). Pass force=true to interrupt an
       in-flight transition immediately instead of waiting for it to finish. */
    function goTo(targetIdx, dir, force) {
      if (!gallery) return;

      if (busy) {
        if (!force) return;
        /* Cut the current transition short and park its slide cleanly
           before starting the new one, so nothing is left mid-flight. */
        if (pendingParkTimeout) { clearTimeout(pendingParkTimeout); pendingParkTimeout = null; }
        if (lastOutgoingEl) {
          lastOutgoingEl.style.transition = 'none';
          lastOutgoingEl.style.transform  = OFF_RIGHT;
        }
        busy = false;
      }

      var vis = getVis();
      if (vis.length <= 1 || targetIdx === curIdx) return;

      busy = true;
      var outgoing = vis[curIdx];
      var incoming = vis[targetIdx];
      lastOutgoingEl = outgoing;

      /* Place incoming slide just off-screen on the correct side */
      incoming.style.transition = 'none';
      incoming.style.transform  = dir > 0 ? OFF_RIGHT : OFF_LEFT;
      void incoming.offsetWidth; /* reflow */

      /* Slide both in/out simultaneously */
      var ease = 'transform 0.55s cubic-bezier(0.65, 0, 0.35, 1)';
      incoming.style.transition = ease;
      incoming.style.transform  = 'translateX(0)';
      incoming.classList.add('nc-active');

      outgoing.style.transition = ease;
      outgoing.style.transform  = dir > 0 ? OFF_LEFT : OFF_RIGHT;
      outgoing.classList.remove('nc-active');

      curIdx = targetIdx;
      updateDot();
      updateProgress();
      playVideoInSlide(incoming);
      pauseVideoInSlide(outgoing);

      pendingParkTimeout = setTimeout(function() {
        /* Park outgoing slide off-screen right (default resting position) */
        outgoing.style.transition = 'none';
        outgoing.style.transform  = OFF_RIGHT;
        busy = false;
        pendingParkTimeout = null;
      }, 560);
    }

    function navigate(dir) {
      if (!gallery) return;
      var vis = getVis();
      if (vis.length <= 1) return;
      goTo((curIdx + dir + vis.length) % vis.length, dir);
    }

    /* Glide straight back to the first slide — interrupts any in-flight
       auto-swipe transition immediately instead of waiting for it. */
    function goToFirstSmooth() {
      if (!gallery || curIdx === 0) return;
      goTo(0, -1, true);
    }

    /* ── Desktop-only hover auto-swipe (min-width: 990px) ──
       Shared by mouseenter AND the prev/next arrows, so a manual arrow
       click while hovering restarts the auto-cycle instead of fighting it.
       The cycle only ever visits real image slides (video slides, and any
       colour-variant slides hidden by applyFilter, are skipped entirely —
       not just on the first jump — so the sequence never stalls on them). */
    var hoverTimer        = null;
    var hoverStartTimeout = null;
    var HOVER_DELAY       = 1200;
    var HOVER_IMAGE_NUM   = 5; /* jump straight to the 5th product image on hover */
    var desktopMQ         = gallery ? window.matchMedia('(min-width: 990px)') : null;
    var isHovering         = false;
    var imgCyclePos        = 0; /* current position within the image-only slide list */

    function stopHoverAutoplay() {
      if (hoverTimer) { clearInterval(hoverTimer); hoverTimer = null; }
      if (hoverStartTimeout) { clearTimeout(hoverStartTimeout); hoverStartTimeout = null; }
    }

    /* Move to the image at `pos` (wrapping) within the current set of
       visible, non-video slides. Recomputes the image list live so it
       stays correct if applyFilter has hidden/shown slides. */
    function goToImagePos(pos) {
      var imgSlides = getVis().filter(function(s) { return !s.dataset.videoId; });
      if (!imgSlides.length) return;
      var idx = ((pos % imgSlides.length) + imgSlides.length) % imgSlides.length;
      var target = imgSlides[idx];
      var targetIdx = getVis().indexOf(target);
      if (targetIdx > -1) goTo(targetIdx, 1);
      imgCyclePos = idx;
    }

    function startHoverAutoplay() {
      stopHoverAutoplay();
      if (!desktopMQ || !desktopMQ.matches) return;
      var imgSlides = getVis().filter(function(s) { return !s.dataset.videoId; });
      if (imgSlides.length <= 1) return;
      hoverStartTimeout = setTimeout(function() {
        hoverTimer = setInterval(function() { goToImagePos(imgCyclePos + 1); }, HOVER_DELAY);
      }, HOVER_DELAY);
    }

    if (gallery) {
      card.addEventListener('mouseenter', function() {
        isHovering = true;
        var imgSlides = getVis().filter(function(s) { return !s.dataset.videoId; });
        if (!desktopMQ.matches || imgSlides.length <= 1) return;
        goToImagePos(HOVER_IMAGE_NUM - 1); /* first swap happens immediately on hover */
        startHoverAutoplay();
      });

      card.addEventListener('mouseleave', function() {
        isHovering = false;
        stopHoverAutoplay();
        goToFirstSmooth();
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation();
      navigate(-1);
      if (isHovering) startHoverAutoplay(); /* don't let auto-swipe fight the manual click */
    });
    if (nextBtn) nextBtn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation();
      navigate(1);
      if (isHovering) startHoverAutoplay();
    });

    /* ── Touch / mouse drag swipe ── */
    if (gallery) {
      var swipeStartX = 0;
      var swipeStartY = 0;
      var swipeDelta  = 0;
      var swiping     = false;
      var swipeAxis   = null; /* 'h' | 'v' | null */
      var wasDrag     = false;
      var THRESHOLD   = 40;

      /* Prevent browser native image/link drag from stealing the pointer */
      gallery.addEventListener('dragstart', function(e) { e.preventDefault(); });

      gallery.addEventListener('touchstart', function(e) {
        var t = e.touches[0];
        swipeStartX = t.clientX;
        swipeStartY = t.clientY;
        swipeDelta  = 0;
        swiping     = true;
        swipeAxis   = null;
        wasDrag     = false;
      }, { passive: true });

      gallery.addEventListener('touchmove', function(e) {
        if (!swiping) return;
        var dx = e.touches[0].clientX - swipeStartX;
        var dy = e.touches[0].clientY - swipeStartY;
        if (!swipeAxis) {
          swipeAxis = Math.abs(dx) >= Math.abs(dy) ? 'h' : 'v';
        }
        if (swipeAxis === 'h') {
          e.preventDefault();
          swipeDelta = dx;
        }
      }, { passive: false });

      gallery.addEventListener('touchend', function() {
        if (!swiping) return;
        swiping = false;
        if (swipeAxis === 'h' && Math.abs(swipeDelta) > THRESHOLD) {
          wasDrag = true;
          navigate(swipeDelta < 0 ? 1 : -1);
        }
        swipeDelta = 0;
      });

      /* Mouse drag (desktop)
         Swiper uses pointerdown internally, so we must intercept pointerdown
         (not mousedown) and stop propagation to prevent Swiper from starting
         its own drag when the user drags on the image gallery.
         We only intercept pointerType === 'mouse' — touch is handled separately. */
      gallery.addEventListener('pointerdown', function(e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        e.stopPropagation();
        swipeStartX = e.clientX;
        swipeDelta  = 0;
        swiping     = true;
        wasDrag     = false;

        function onMove(ev) {
          swipeDelta = ev.clientX - swipeStartX;
        }
        function onUp() {
          document.removeEventListener('pointermove', onMove);
          document.removeEventListener('pointerup', onUp);
          if (!swiping) return;
          swiping = false;
          if (Math.abs(swipeDelta) > THRESHOLD) {
            wasDrag = true;
            navigate(swipeDelta < 0 ? 1 : -1);
          }
          swipeDelta = 0;
        }
        document.addEventListener('pointermove', onMove);
        document.addEventListener('pointerup', onUp);
      });

      /* Block click-through after a drag — wasDrag is set before click fires */
      gallery.addEventListener('click', function(e) {
        if (wasDrag) {
          e.preventDefault();
          e.stopPropagation();
          wasDrag = false;
        }
      }, true);
    }

    /* ── Video play button ── */
    card.querySelectorAll('[data-play-btn]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        var wrap  = btn.closest('[data-video-wrap]');
        var video = wrap && wrap.querySelector('[data-video-el]');
        if (video && wrap) {
          wrap.classList.add('playing');
          video.play().catch(function() {});
        }
      });
    });

    function selectSwatch(sw) {
      swatches.forEach(function(s) { s.classList.remove(swatchActiveClass); });
      sw.classList.add(swatchActiveClass);
      if (label) label.textContent = sw.dataset.swatchLabel;
      applyFilter(sw.dataset.swatchVariantId);
    }

    /* ── Price filter active → show price / compare at price of a variant inside the range ── */
    var priceEl = card.querySelector('.nc-col-card__price');
    var originalPriceHtml = priceEl ? priceEl.innerHTML : '';
    var priceData = null;
    var priceDataEl = card.querySelector('script[data-nc-variant-prices]');
    if (priceDataEl) {
      try { priceData = JSON.parse(priceDataEl.textContent); } catch (e) {}
    }

    function renderVariantPrice(v) {
      var price = formatMoney(v[1], priceData.money);
      if (!price) return;
      var onSale = v[2] > v[1];
      var badge = priceEl.querySelector('.price__badge-sale');
      var badgeUsed = badge && badge.textContent.trim() !== '';
      priceEl.innerHTML = onSale
        ? '<span class="price--sale">' + price + '</span> <span class="price--compare">' + formatMoney(v[2], priceData.money) + '</span> '
        : '<span>' + price + '</span> ';
      if (badge) {
        if (badgeUsed) badge.textContent = (onSale ? Math.round((v[2] - v[1]) * 100 / v[2]) : 0) + '% off';
        badge.style.display = badgeUsed && !onSale ? 'none' : '';
        priceEl.appendChild(badge);
      }
      linkToVariant(v[0]);
    }

    /* Product links open the shown variant (?variant=id); null restores the original links */
    var productLinks = Array.from(card.querySelectorAll('a[href]')).filter(function(a) {
      return a.getAttribute('href').indexOf('/products/') > -1;
    });
    function linkToVariant(variantId) {
      productLinks.forEach(function(a) {
        if (a.dataset.ncHref === undefined) a.dataset.ncHref = a.getAttribute('href');
        var url = new URL(a.dataset.ncHref, window.location.origin);
        if (variantId) url.searchParams.set('variant', variantId);
        a.setAttribute('href', url.pathname + url.search + url.hash);
      });
    }

    function cheapest(list) {
      return list.reduce(function(best, v) { return !best || v[1] < best[1] ? v : best; }, null);
    }

    // color: swatch the visitor just picked (undefined = keep the active swatch when it has a match)
    function syncPrice(color) {
      if (!priceEl || !priceData || !priceData.variants) return;
      var range = activePriceRange();
      if (!range) {
        if (priceEl.innerHTML !== originalPriceHtml) priceEl.innerHTML = originalPriceHtml;
        linkToVariant(null);
        return;
      }
      var inRange = priceData.variants.filter(function(v) { return v[1] >= range.min && v[1] <= range.max; });
      var activeSw = card.querySelector('.' + swatchActiveClass);
      var wanted = color !== undefined ? color : (activeSw ? (activeSw.dataset.swatchLabel || '').toLowerCase() : '');
      var ofColor = function(list) { return list.filter(function(v) { return v[3] === wanted; }); };

      var variant = cheapest(ofColor(inRange));
      if (!variant && color !== undefined) variant = cheapest(ofColor(priceData.variants));
      if (!variant) {
        variant = cheapest(inRange);
        // Switch the card to that variant's colour as well
        var sw = variant && swatches.filter(function(s) { return (s.dataset.swatchLabel || '').toLowerCase() === variant[3]; })[0];
        if (sw && sw !== activeSw) selectSwatch(sw);
      }
      if (variant) renderVariantPrice(variant);
    }

    card.__ncSyncPrice = function() { syncPrice(); };

    /* ── Swatch click → filter + update label (+ price when a price filter is active) ── */
    swatches.forEach(function(sw) {
      sw.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        selectSwatch(sw);
        syncPrice((sw.dataset.swatchLabel || '').toLowerCase());
      });
    });

    /* ── Wishlist toggle ── */
    var wBtn = card.querySelector('[data-wishlist-id]');
    if (wBtn) {
      wBtn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        wBtn.classList.toggle('is-wished');
      });
    }

    /* ── Init: apply first swatch filter, then set slide positions ── */
    if (swatches.length > 0 && productId) {
      applyFilter(swatches[0].dataset.swatchVariantId);
    } else {
      resetSlides();
    }
    syncPrice();
  }

  function initAll() {
    document.querySelectorAll('[data-nc-card]').forEach(function(card) {
      if (!card.dataset.ncInit) {
        card.dataset.ncInit = '1';
        initCard(card);
      }
    });
  }

  window.__NCInitCards = initAll;

  document.readyState !== 'loading' ? initAll() : document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  // product-recommendations loads cards via AJAX — observe for newly injected [data-nc-card] elements
  var _ncCardObserverTimer;
  new MutationObserver(function() {
    clearTimeout(_ncCardObserverTimer);
    _ncCardObserverTimer = setTimeout(function() {
      document.querySelectorAll('[data-nc-card]:not([data-nc-init])').forEach(function(card) {
        card.dataset.ncInit = '1';
        initCard(card);
      });
    }, 50);
  }).observe(document.body, { childList: true, subtree: true });
})();
